// Copyright (c) Frisbii GmbH. All rights reserved.
'use strict';

/* Directives */
var FLOAT_REGEXP = /^\-?\d+((\.|\,)\d+)?$/;
itero.directive('smartFloat', function () {
    return {
        require: 'ngModel',
        link: function (scope, elm, attrs, ctrl) {
            ctrl.$parsers.unshift(function (viewValue) {
                if (!viewValue) {
                    return viewValue;
                }
                if (FLOAT_REGEXP.test(viewValue)) {
                    ctrl.$setValidity('float', true);
                    return parseFloat(viewValue.replace(',', '.'));
                } else {
                    ctrl.$setValidity('float', false);
                    return undefined;
                }
            });
            ctrl.$formatters.push(function (value) {
                if (angular.isNumber(value))
                    return (value + "").replace('.', ',');
                else
                    return "";
            });
        }
    };
});

var MultiSelectTreeController = function ($scope, $document) {

    var activeItem;
    $scope.showTree = false;
    $scope.selectedItems = [];
    $scope.searchFilter = '';
    $scope.multiSelect = $scope.multiSelect || false;

    /**
     * Clicking on document will hide the tree.
     */
    function docClickHide() {
        closePopup();
        $scope.$apply();
    }
    
    $scope.changeTreeState = function (newState){
        if (newState !== undefined && newState !== null){
            $scope.currentState = newState;
        }
    }

    /**
     * Closes the tree popup.
     */
    function closePopup() {
        $scope.showTree = false;
        if (activeItem) {
            activeItem.isActive = false;
            activeItem = undefined;
        }
        $document.off('click', docClickHide);
    }

    /**
     * Sets the active item.
     *
     * @param item the item element.
     */
    $scope.onActiveItem = function (item) {
        if (activeItem !== item) {
            if (activeItem) {
                activeItem.isActive = false;
            }
            activeItem = item;
            activeItem.isActive = true;
        }
    };
    
    $scope.isInState = function (){
        let args = Array.prototype.slice.call(arguments);
        
        return args.includes($scope.currentState);
    }
    
    $scope.openTreeForSelectedListElement = function ($event, item){
        $event.stopPropagation();
        $scope.searchCallback({searchEntityId : item.Id, treeState: $scope.currentState});
    }

    /**
     * Copies the selectedItems in to output model.
     */
    $scope.refreshOutputModel = function () {
        $scope.outputModel = angular.copy($scope.selectedItems);
    };

    /**
     * Refreshes the selected Items model.
     */
    $scope.refreshSelectedItems = function () {
        $scope.selectedItems = [];
        if ($scope.inputModel.items) {
            setSelectedChildren($scope.inputModel.items);
        }
    };
    
    $scope.unselectAll = function () {
        $scope.selectedItems = [];
        this.refreshOutputModel();
    }

    /**
     * Iterates over children and sets the selected items.
     *
     * @param children the children element.
     */
    function setSelectedChildren(children) {
        for (var i = 0, len = children.length; i < len; i++) {
            if (!isItemSelected(children[i]) && children[i].selected === true) {
                $scope.selectedItems.push(children[i]);
            } else if (isItemSelected(children[i]) && children[i].selected === false) {
                children[i].selected = true;
            }
            if (children[i] && children[i].children) {
                setSelectedChildren(children[i].children);
            }
        }
    }

    /**
     * Checks of the item is already selected.
     *
     * @param item the item to be checked.
     * @return {boolean} if the item is already selected.
     */
    function isItemSelected(item) {
        var isSelected = false;
        if ($scope.selectedItems) {
            for (var i = 0; i < $scope.selectedItems.length; i++) {
                if ($scope.selectedItems[i].id === item.id) {
                    isSelected = true;
                    break;
                }
            }
        }
        return isSelected;
    }

    /**
     * Deselect the item.
     *
     * @param item the item element
     * @param $event
     */
    $scope.deselectItem = function (item, $event) {
        $event.stopPropagation();
        $scope.selectedItems.splice($scope.selectedItems.indexOf(item), 1);
        item.selected = false;
        this.refreshOutputModel();
    };

    /**
     * Swap the tree popup on control click event.
     *
     * @param $event the click event.
     */
    
    $scope.onControlClicked = function ($event) {
        $event.stopPropagation();
        $scope.showTree = !$scope.showTree;
        if ($scope.showTree) {
            $document.on('click', docClickHide);
        }
    };

    /**
     * Stop the event on filter clicked.
     *
     * @param $event the click event
     */
    $scope.onFilterClicked = function ($event) {
        $event.stopPropagation();
    };

    $scope.applyFilter = function ($event) {
        if ($event) {
            $event.stopPropagation();
        }
        $scope.currentState = $scope.searchFilter.length === 0 ? $scope.multiSelectStates.OutputAsTree : $scope.multiSelectStates.PendingForSearch;
        $scope.searchCallback({searchQuery: $scope.searchFilter, treeState: $scope.currentState});
    };
    
    /**
     * Clears the filter text.
     *
     * @param $event the click event
     */
    $scope.clearFilter = function ($event) {
        $event.stopPropagation();
        $scope.searchFilter = '';
        $scope.currentState = $scope.multiSelectStates.OutputAsTree;
        $scope.searchCallback({searchQuery: $scope.searchFilter, treeState: $scope.currentState});
    };

    /**
     * Wrapper function for can select item callback.
     *
     * @param item the item
     */
    $scope.canSelectItem = function (item) {
        return $scope.callback({item: item, selectedItems: $scope.selectedItems});
    };

    /**
     * The callback is used to switch the views.
     * based on the view type.
     *
     * @param $event the event object.
     */
    $scope.switchCurrentView = function ($event) {
        $event.stopPropagation();
        $scope.switchViewCallback({scopeObj: $scope});
    };

    /**
     * Handles the item select event.
     *
     * @param item the selected item.
     */
    $scope.itemSelected = function (item) {
        if (($scope.useCallback && $scope.canSelectItem(item) === false) ||
            ($scope.selectOnlyLeafs && item.children && item.children.length > 0)) {
            return;
        }

        if (!$scope.multiSelect) {
            closePopup();
            for (var i = 0; i < $scope.selectedItems.length; i++) {
                $scope.selectedItems[i].selected = false;
            }
            item.selected = true;
            $scope.selectedItems = [];
            $scope.selectedItems.push(item);
        } else {
            item.selected = true;
            var indexOfItem = $scope.selectedItems.indexOf(item);
            if (isItemSelected(item)) {
                item.selected = false;
                $scope.selectedItems.splice(indexOfItem, 1);
            } else {
                $scope.selectedItems.push(item);
            }
        }
        this.refreshOutputModel();
    };

};

MultiSelectTreeController.$inject = ["$scope", "$document"];

var TreeItemController = function ($scope) {
    $scope.item.isExpanded = false;

    /**
     * Shows the expand option.
     *
     * @param item the item
     * @returns {*|boolean}
     */
    $scope.showExpand = function (item) {
        return item.children && item.children.length > 0;
    };

    /**
     * On expand clicked toggle the option.
     *
     * @param item the item
     * @param $event
     */
    $scope.onExpandClicked = function (item, $event) {
        $event.stopPropagation();
        item.isExpanded = !item.isExpanded;
    };

    /**
     * Event on click of select item.
     *
     * @param item the item
     * @param $event
     */
    $scope.clickSelectItem = function (item, $event) {
        $event.stopPropagation();
        if ($scope.itemSelected) {
            $scope.itemSelected({item: item});
        }
    };

    /**
     * Is leaf selected.
     *
     * @param item the item
     * @param $event
     */
    $scope.subItemSelected = function (item, $event) {
        if ($scope.itemSelected) {
            $scope.itemSelected({item: item});
        }
    };

    /**
     * Active sub item.
     *
     * @param item the item
     * @param $event
     */
    $scope.activeSubItem = function (item, $event) {
        if ($scope.onActiveItem) {
            $scope.onActiveItem({item: item});
        }
    };

    /**
     * On mouse over event.
     *
     * @param item the item
     * @param $event
     */
    $scope.onMouseOver = function (item, $event) {
        $event.stopPropagation();
        if ($scope.onActiveItem) {
            $scope.onActiveItem({item: item});
        }
    };

    /**
     * Can select item.
     *
     * @returns {*}
     */
    $scope.showCheckbox = function () {
        if (!$scope.multiSelect) {
            return false;
        }

        if ($scope.selectOnlyLeafs) {
            return false;
        }

        if ($scope.useCallback) {
            return $scope.canSelectItem($scope.item);
        }
    };
}

TreeItemController.$inject = ["$scope"];

var LocalizationControlController = function ($scope, $modalInstance) {
    var data = $scope.data;
    $scope.newItem = {};

    if (typeof (data) === "object")
        $scope.keys = Object.keys(data);
    else
        $scope.keys = [];

    $scope.close = function () {
        $modalInstance.dismiss();
    };

    $scope.add = function () {
        if($scope.data[$scope.newItem.key])
        {
            return;
        }
        $scope.data[$scope.newItem.key] = $scope.newItem.value;
        $scope.newItem.value = null;
        $scope.newItem.key = null;
        $scope.keys = Object.keys(data);
    };

    $scope.remove = function (key) {
        delete $scope.data[key];
    };

    $scope.isDefaultTranslate = function (key) {
        return key != '_c';
    }
    
    $scope.isOkButtonDisabled = function () {
       return  Object.keys($scope.data).some(function (key) {
            return !$scope.data[key] || $scope.data[key].length === 0; 
        })
    }
    
};

LocalizationControlController.$inject = ["$scope", "$uibModalInstance"];

var PriceControlController = function ($rootScope, $scope, $modalInstance) {
    $scope.pricingModel = "3";
    if ($scope.data.PricePerUnit != null) $scope.pricingModel = "0";
    if ($scope.data.PriceScale != null) $scope.pricingModel = "1";
    if ($scope.data.DiscountScale != null) $scope.pricingModel = "2";

    if ($scope.data.PriceScale != null && $scope.data.PriceScale.Items != null && $scope.data.PriceScale.Items.length > 0)
        $scope.isBucketPricing = $scope.data.PriceScale.Items[0].IsBucketPrice;

    $scope.$watch('pricingModel', function(newValue) {
        if (newValue != "0") $scope.data.PricePerUnit = null;
        if (newValue != "1") $scope.data.PriceScale = null;
        if (newValue != "2") $scope.data.DiscountScale = null;
    });
    
    $scope.setBucketPricing = function () {
        if ($scope.data.PriceScale) {
            if ($scope.data.PriceScale.Items != null) {
                for (var i = 0; i < $scope.data.PriceScale.Items.length; ++i)
                    $scope.data.PriceScale.Items[i].IsBucketPrice = $scope.isBucketPricing;
                if ($scope.data.PriceScale.Items.length > 0)
                    $scope.data.PriceScale.Items[$scope.data.PriceScale.Items.length - 1].IsBucketPrice = false;
            }
        }
    };

    $scope.addPriceScale = function () {
        if (!$scope.data.PriceScale)
            $scope.data.PriceScale = { Items: [] };
        if (!$scope.data.PriceScale.Items)
            $scope.data.PriceScale.Items = [];
        $scope.data.PriceScale.Items.push({ From: 0, Value: 0 });
        $scope.setBucketPricing();
    };

    $scope.removePriceScale = function (price) {
        $scope.data.PriceScale.Items.remove(price);
        $scope.setBucketPricing();
    };

    $scope.addDiscountScale = function () {
        if (!angular.isDefined($scope.data.DiscountScale))
            $scope.data.DiscountScale = { Items: [] };
        if (!angular.isDefined($scope.data.DiscountScale.Items))
            $scope.data.DiscountScale.Items = [];
        $scope.data.DiscountScale.Items.push({ From: 0, Value: 0 });
    };

    $scope.removeDiscountScale = function (index) {
        $scope.data.DiscountScale.Items.remove(index);
    };

    $scope.close = function () {
        $modalInstance.dismiss('cancel');
    };

    $scope.save = function () {
        if (!$rootScope.isValid($scope.form) && $scope.pricingModel !== "3") {
            return;
        }
        $modalInstance.dismiss('save');
    };
};

PriceControlController.$inject = ["$rootScope", "$scope", "$uibModalInstance"];

itero.directive('l10nEditor', function () {
    return {
        restrict: 'E',
        scope: { data: '=ngModel', optional: '=optional', readonly: '=readonly', noHint: '=noHint', size: '=size' },
        templateUrl: '/partials/controls/localization-editor.html' + itero.linkVersion,
        controller: ['$scope', '$uibModal',
            function ($scope, $modal) {
                $scope.openEditor = function () {
                    if (!$scope.data._c) return;

                    $modal.open({
                        templateUrl: '/partials/controls/localization-editor-dialog.html' + itero.linkVersion,
                        controller: LocalizationControlController,
                        windowClass: "fade in",
                        scope: $scope
                    });
                };
            }]
    };
});

itero.directive('l10nTextarea', function () {
    return {
        restrict: 'E',
        scope: {
            data: '=ngModel',
            elementid: '@elementId',
            focusedElement: '=focusedElement'
        },
        templateUrl: '/partials/controls/localization-textarea.html' + itero.linkVersion,
        controller: ['$scope', '$uibModal',
            function ($scope, $modal) {
                $scope.openEditor = function () {
                    if (!$scope.data._c) return;

                    $modal.open({
                        templateUrl: '/partials/controls/localization-editor-textarea-dialog.html' + itero.linkVersion,
                        controller: LocalizationControlController,
                        windowClass: "localization-editor--container fade in",
                        resolve: { data: function () { return $scope.data; } },
                        scope: $scope
                    });
                };
            }]
    };
});

itero.directive('l10nInput', function () {
    return {
        restrict: 'E',
        scope: {
            data: '=ngModel',
            elementid: '@elementId',
            focusedInput: '=focusedInput',
        },
        templateUrl: '/partials/controls/focused-input.html' + itero.linkVersion,
     };
});

itero.directive('countryDropdown', ['CountryList', 'gettextCatalog', function (CountryList, gettextCatalog) {
    return {
        restrict: 'E',
        // NOTE: don't use 'disabled' here, because you'd have to use disabled="true", which conflicts w/ HTML
        scope: {
            model: '=ngModel',
			pactasDisabled: '=pactasDisabled',
			required: '@pactasRequired',
            filterFn: '=filterFn',
            change: '=ngChange',
            countries: '=?countries',
            tryLoadCountryWhiteList: '@'
        },
        templateUrl: '/partials/controls/country-dropdown.html' + itero.linkVersion,
        link: function (scope, elem, attr) {
            scope.language = gettextCatalog.currentLanguage;
            scope.filter = function (entry) { return scope.filterFn ? scope.filterFn(entry.TwoLetterCode) : true; };
            scope.tryLoadCountryWhiteList = angular.isDefined(scope.tryLoadCountryWhiteList) ? scope.tryLoadCountryWhiteList : false;
            
            if (!scope.countries) {
                CountryList.getCountries(scope.tryLoadCountryWhiteList).then(function (response) {
                    scope.countries = response.data;
                    },
                    function () { }); // TODO: Custom error handling?
            }
        }
    };
}]);

itero.directive('stateDropdown', ['CountryStates', function (CountryStates) {
    return {
        restrict: 'E',
        scope: {
            model: '=ngModel',
            pactasDisabled: '=pactasDisabled',
            required: '@pactasRequired',
            filterFn: '=filterFn',
            change: '=ngChange',
            states: '=?states'
        },
        templateUrl: '/partials/controls/state-dropdown.html' + itero.linkVersion
    };
}]);


itero.directive('entityusecodeDropdown', ['EntityUseCodes', function (EntityUseCodes) {
    return {
        restrict: 'E',
        scope: {
            model: '=ngModel',
            pactasDisabled: '=pactasDisabled',
            required: '@pactasRequired',
            filterFn: '=filterFn'
        },
        templateUrl: '/partials/controls/entityusecode-dropdown.html' + itero.linkVersion,
        link: function (scope, elem, attr) {

            EntityUseCodes.getCodes().then(function (response) {
                    scope.entityUseCodes = response.data;
                },
                function () { }); // TODO: Custom error handling?
        }
    };
}]);

itero.directive('languageDropdown', ['LocaleList', 'gettextCatalog', function (LocaleList, gettextCatalog) {
    return {
        restrict: 'E',
        scope: {
            model: '=ngModel', disabled: '@pactasDisabled', required: '@pactasRequired'
        },
        templateUrl: '/partials/controls/locale-dropdown.html' + itero.linkVersion,
        link: function (scope, elem, attr) {
            scope.language = gettextCatalog.currentLanguage;
            LocaleList.getLocales().then(function (response) {
                scope.locales = response.data;
            },
                function () { }); // TODO: Custom error handling?
        }
    };
}]);

itero.directive('periodEditor', function () {
    return {
        restrict: 'E',
        scope: { model: '=ngModel', dis: '=pactasDisabled', req: '=pactasRequired', min: '=min', max: '=max' },
        templateUrl: '/partials/controls/period-editor.html' + itero.linkVersion
    };
});

itero.directive('paginatorControls', function () {
    return {
        restrict: 'E',
        scope: { model: '=ngModel' },
        templateUrl: '/partials/controls/paginator-controls.html' + itero.linkVersion
    };
});

itero.directive('timezoneDropdown', function () {
    return {
        restrict: 'E',
        scope: { model: '=ngModel', disabled: '@pactasDisabled', required: '@pactasRequired' },
        templateUrl: '/partials/controls/timezone-dropdown.html' + itero.linkVersion
    };
});

itero.directive('loading', ['gettextCatalog', 'gettext', function (gettextCatalog, gettext) {
    return {
        restrict: 'E',
        templateUrl: '/partials/controls/loading.html' + itero.linkVersion,
        link: function (scope) {
            scope.label = gettextCatalog.getString(gettext('loading, please wait...')); //Translation does not work within template
        }
    };
}]);

itero.directive('bwloading', function () {
    return {
        restrict: 'E',
        scope: { name: '@name' },
        templateUrl: '/partials/controls/bwloading.html' + itero.linkVersion,
        link: function (scope, element, attrs) {

            var shownType = element.css('display');

            function hideElement() {
                element.css('display', 'none');
            }

            scope.$on('startLoading', function (event, args) {
                if (scope.name === args.name) {
                    element.css('display', shownType);
                }
            });
            scope.$on('stopLoading', function (event, args) {
                if (scope.name === args.name) {
                    hideElement()
                }
            });

            if (attrs.overlay == 'true') {
                element.css('width', element.find("div")[0].clientWidth);
                element.css('position', 'absolute');
            }
            hideElement();
        }
    };
});

itero.directive('infobox', function () {
    return {
        restrict: 'E',
        scope: { pactasShow: '&', header: '@' },
        transclude: true,
        templateUrl: '/partials/controls/infobox.html' + itero.linkVersion
    };
});

itero.directive('switch', function () {
    return {
        restrict: 'E',
        scope: { model: '=ngModel', pactasDisabled: '&', pactasOnAction: '&', pactasOffAction: '&', inverted: '=' },
        templateUrl: '/partials/controls/switch.html' + itero.linkVersion,
        replace: false,
        link: function(scope, element, attrs) {
            scope.on = function () {
                angular.element(document.activeElement).blur();
                scope.pactasOnAction();
            }
            scope.off = function () {
                angular.element(document.activeElement).blur();
                scope.pactasOffAction();
            }
        }
    };
});

itero.directive('money', function () {
    return {
        restrict: 'E',
        scope: { model: '=ngModel', currency: '@currency', disabled: '@pactasDisabled', required: '@pactasRequired' },
        templateUrl: '/partials/controls/money.html' + itero.linkVersion,
        replace: true
    };
});

itero.directive('taxpolicy', function () {
    return {
        restrict: 'E',
        scope: { model: '=ngModel', policies: '=policies', disabled: '@pactasDisabled', required: '=pactasRequired' },
        templateUrl: '/partials/controls/taxpolicy.html' + itero.linkVersion,
        replace: true
    };
});

itero.directive('invoice', function () {
    return {
        restrict: 'E',
        scope: { invoice: '=invoice', editable: '@editable', embedded:"=embedded", showBookedQuantity:"=showBookedQuantity" },
        templateUrl: '/partials/controls/invoice.html' + itero.linkVersion,
        replace: true,
        link: function (scope) {
            scope.sign = function () {
                if (scope.invoice) {
                    return scope.invoice.IsInvoice ? +1 : -1;
                }
            };
            scope.isPricedIndividually = function (item) {
                if (!item.ScaleAmount)
                    return item.Quantity == item.BookedQuantity;
                else
                    return item.ScaleAmount == Math.abs(item.BookedQuantity);
            }
        }
    };
});

itero.directive('invoices', function () {
    return {
        restrict: 'E',
        scope: { invoice: '=invoice', editable: '@editable', embedded: "=embedded", showBookedQuantity: "=showBookedQuantity" },
        templateUrl: '/partials/controls/invoices.html' + itero.linkVersion,
        replace: true,
        link: function (scope) {
            scope.getInvoiceSign = function () {
                if (scope.invoice) {
                    return scope.invoice.IsInvoice ? +1 : -1;
                }
            };
            
            scope.isGrossPriceTax = function () {
                return scope.invoice.PriceTaxType === 'Gross'
            }

            scope.isNetPriceTax = function () {
                return scope.invoice.PriceTaxType === 'Net'
            }
            
            scope.isMultiEntries = function () {
                return scope.invoice.Entries.length > 1
            }

            scope.isPricedIndividually = function (item) {
                if (!item.ScaleAmount)
                    return item.Quantity == item.BookedQuantity;
                else
                    return item.ScaleAmount == Math.abs(item.BookedQuantity);
            }
        }
    };
});

itero.directive('vatIdWithCountryCheck', ['VatIdService', function (VatIdService) {
    return {
        require: 'ngModel',
        scope: { country:'=vatIdCountry'},
        link: function (scope, elm, attrs, ctrl) {
            scope.$watch('country', function (newValue, oldValue) {
                if (newValue !== oldValue) {
                    const validity= VatIdService.validate(ctrl.$viewValue, newValue);
                    ctrl.$setValidity('vatId', validity);
                }
            });

            ctrl.$parsers.unshift(function (viewValue) {

                if (VatIdService.validate(viewValue, scope.country)) {
                    ctrl.$setValidity('vatId', true);
                    return viewValue;
                }

                ctrl.$setValidity('vatId', false);
                return undefined;
            });
            ctrl.$formatters.push(function (value) {
                return value;
            });
        }
    };
}]);

itero.directive('vatId', ['VatIdService', function (VatIdService) {
    return {
        require: 'ngModel',
        link: function (scope, elm, attrs, ctrl) {

            ctrl.$parsers.unshift(function (viewValue) {

                if (VatIdService.validate(viewValue)) {
                    ctrl.$setValidity('vatId', true);
                    return viewValue;
                }

                ctrl.$setValidity('vatId', false);
                return undefined;
            });
            ctrl.$formatters.push(function (value) {
                return value;
            });
        }
    };
}]);

itero.directive('iban', function () {
    return {
        require: 'ngModel',
        link: function (scope, elm, attrs, ctrl) {
            ctrl.$parsers.unshift(function (viewValue) {
                if (viewValue) {

                    if (IBAN.isValid(viewValue)) {
                        ctrl.$setValidity('iban', true);
                        return viewValue;
                    }
                }
                if (viewValue === "") {
                    ctrl.$setValidity('iban', true);
                    return viewValue;
                }
                ctrl.$setValidity('iban', false);
                return undefined;
            });
            ctrl.$formatters.push(function (value) {
                return value;
            });
        }
    };
});

itero.directive('bic', function () {
    return {
        require: 'ngModel',
        link: function (scope, elm, attrs, ctrl) {
            ctrl.$parsers.unshift(function (viewValue) {
                if (viewValue) {
                    // https://www.iso9362.org/isobic/overview.html
                    var bicRegex = /^([A-Z0-9]{4}[A-Z]{2}[A-Z0-9]{2})([A-Z0-9]{3})?$/;
                    var isBic = bicRegex.test(viewValue.toUpperCase());

                    if (isBic)
                    {
                        ctrl.$setValidity('bic', true);
                        return viewValue;
                    }
                }
                if (viewValue === "") {
                    ctrl.$setValidity('bic', true);
                    return viewValue;
                }
                ctrl.$setValidity('bic', false);
                return undefined;
            });
            ctrl.$formatters.push(function (value) {
                return value;
            });
        }
    };
});

itero.directive('qriban', function () {
    return {
        require: 'ngModel',
        link: function (scope, elm, attrs, ctrl) {
            ctrl.$parsers.unshift(function (viewValue) {
                if (viewValue) {

                    if (IBAN.isValid(viewValue)) {

                        var cleared = viewValue.replace(" ", "").replace("-", "");
                        var qriid = cleared.substr(4, 5);
                        var possibleQrIid = Number(qriid);

                        if (isNaN(possibleQrIid)) {
                            ctrl.$setValidity('qriban', false);
                            return undefined;
                        }

                        var foundQrIid = possibleQrIid >= 30000 && possibleQrIid <= 31999;
                        if (foundQrIid) {
                            ctrl.$setValidity('qriban', true);
                            return viewValue;
                        } else {
                            ctrl.$setValidity('qriban', false);
                            return undefined;
                        }
                    }
                }
                if (viewValue === "") {
                    ctrl.$setValidity('qriban', true);
                    return viewValue;
                }
                ctrl.$setValidity('qriban', false);
                return undefined;
            });
            ctrl.$formatters.push(function (value) {
                return value;
            });
        }
    };
});

itero.directive('creditorIdentifier', function () {
    return {
        require: 'ngModel',
        link: function (scope, elm, attrs, ctrl) {
            ctrl.$parsers.unshift(function (viewValue) {
                if (viewValue && viewValue.length > 6) {
                    var regex = /^[a-zA-Z]{2}[0-9]{2}[a-zA-Z0-9]{3}\w+/;

                    if (regex.test(viewValue)) {
                        ctrl.$setValidity('creditorIdentifier', true);
                        return viewValue;
                    }
                }
                if (viewValue === "") {
                    ctrl.$setValidity('creditorIdentifier', true);
                    return viewValue;
                }
                ctrl.$setValidity('creditorIdentifier', false);
                return undefined;
            });
            ctrl.$formatters.push(function (value) {
                return value;
            });
        }
    };
});

itero.directive("inputDate", ['$filter', function ($filter) {
    return {
        restrict: 'A',
        require: 'ngModel',
        // replace: true,
        link: function (scope, element, attrs, ctrl) {
            ctrl.$formatters.push(function (value) {
                if (angular.isString(value)) {
                    var result = $filter('date')(value);
                    return result;
                }
            });
            ctrl.$parsers.push(function (value) {
                if (angular.isDate(value)) {
                    var result = moment(value).utc().format();
                    return result;
                }
                else if (angular.isString(value)) {
                    // TBD: Locale dependency!
                    var result = moment(value, "DD.MM.YYYY").utc().format();
                    return result;
                }
            });
        }
    };
}]);

itero.directive('auditlogDetails', function () {
    return {
        restrict: 'EA',
        scope: { auditlog: '=', loading: '=', heightBlockId: '=' },
        templateUrl: 'partials/auditLogs-details.html' + itero.linkVersion,
        replace: true,
        link: function (scope, element, attrs, ctrl) {
            scope.$watch(
                function () {
                    var el = document.getElementById(scope.heightBlockId);
                    return el ? el.offsetHeight : 0;
                },
                function (newVal, oldVal) {
                    if (newVal !== oldVal && newVal !== 0)
                        scope.minHeight = newVal;
                });
        },

        controller: ['$scope',
            function ($scope) {
                $scope.ChangeKind = {
                    Create: 'Create',
                    Update: 'Update',
                    Delete: 'Delete',
                    DeletionRequested: 'DeletionRequested',
                };

                $scope.isJson = function(input) {
                    input = typeof input !== "string" ? JSON.stringify(input) : input;

                    try {
                        input = JSON.parse(input);
                    } catch (e) {
                        return false;
                    }

                    if (typeof input === "object" && input !== null) {
                        return true;
                    }

                    return false;
                };

                $scope.getIsDataChangesVisible = function(auditLog) {
                    if (isAuditLogVisible(auditLog) === false) {
                        return false;
                    }
                    return auditLog.DataChanges.length > 0;
                };

                $scope.getIsMoreDetailsVisible = function(auditLog) {
                    if (isAuditLogVisible(auditLog) === false) {
                        return false;
                    }
                    return auditLog.DisplayFields.length > 0;
                };

                function isAuditLogVisible(auditLog) {
                    if (auditLog == null ||
                        auditLog.DataChanges == null) {
                        return false;
                    }
                    return true;
                }

                $scope.getIsNewSectionVisible = function(change) {
                    return change.ChangeKind === $scope.ChangeKind.Create 
                        || change.ChangeKind === $scope.ChangeKind.Update 
                        || change.ChangeKind === $scope.ChangeKind.DeletionRequested;
                };

                $scope.getIsOldSectionVisible = function(change) {
                    return change.ChangeKind === $scope.ChangeKind.Update 
                        || change.ChangeKind === $scope.ChangeKind.Delete
                        || change.ChangeKind === $scope.ChangeKind.DeletionRequested;
                };

                $scope.getChangeSectionInitialClass = function(auditLog) {
                    if (auditLog.DataChanges.length > 1) {
                        return 'collapse';
                    }
                };
            }]
    };
});

itero.directive('jsonFormattedOutput', function () {
    return {
        restrict: 'E',
        scope: { input: '=' },
        templateUrl: 'partials/controls/json-output.html' + itero.linkVersion,
        replace: true
    };
});
angular.module('ui.config', []).value('ui.config', {});
angular.module('ui.filters', ['ui.config']);
angular.module('ui.directives', ['ui.config']);
angular.module('ui', ['ui.filters', 'ui.directives', 'ui.config']);

/**
* Enhanced Select2 Dropmenus
*
* @AJAX Mode - When in this mode, your value will be an object (or array of objects) of the data used by Select2
*     This change is so that you do not have to do an additional query yourself on top of Select2's own query
* @params [options] {object} The configuration options passed to $.fn.select2(). Refer to the documentation
*/

angular.module('ui.directives').directive('uiSelect2', ['ui.config', '$timeout', function (uiConfig, $timeout) {
    var options = {};
    if (uiConfig.select2) {
        angular.extend(options, uiConfig.select2);
    }
    return {
        require: '?ngModel',
        compile: function (tElm, tAttrs) {
            var watch,
                repeatOption,
                repeatAttr,
                isSelect = tElm.is('select'),
                isMultiple = (tAttrs.multiple !== undefined);

            // Enable watching of the options dataset if in use
            if (tElm.is('select')) {
                repeatOption = tElm.find('option[ng-repeat], option[data-ng-repeat]');

                if (repeatOption.length) {
                    repeatAttr = repeatOption.attr('ng-repeat') || repeatOption.attr('data-ng-repeat');
                    watch = jQuery.trim(repeatAttr.split('|')[0]).split(' ').pop();
                }
            }

            return function (scope, elm, attrs, controller) {
                // instance-specific options
                var opts = angular.extend({}, options, scope.$eval(attrs.uiSelect2));

                if (isSelect) {
                    // Use <select multiple> instead
                    delete opts.multiple;
                    delete opts.initSelection;
                } else if (isMultiple) {
                    opts.multiple = true;
                }

                if (controller) {
                    // Watch the model for programmatic changes
                    controller.$render = function () {
                        if (isSelect) {
                            elm.select2('val', controller.$modelValue);
                        } else {
                            if (isMultiple) {
                                if (!controller.$modelValue) {
                                    elm.select2('data', []);
                                } else if (angular.isArray(controller.$modelValue)) {
                                    elm.select2('data', controller.$modelValue);
                                } else {
                                    elm.select2('val', controller.$modelValue);
                                }
                            } else {
                                if (angular.isObject(controller.$modelValue)) {
                                    elm.select2('data', controller.$modelValue);
                                } else {
                                    elm.select2('val', controller.$modelValue);
                                }
                            }
                        }
                    };

                    // Watch the options dataset for changes
                    if (watch) {
                        scope.$watch(watch, function (newVal, oldVal, scope) {
                            if (!newVal) return;
                            // Delayed so that the options have time to be rendered
                            $timeout(function () {
                                elm.select2('val', controller.$viewValue);
                                // Refresh angular to remove the superfluous option
                                elm.trigger('change');
                            });
                        });
                    }

                    if (!isSelect) {
                        // Set the view and model value and update the angular template manually for the ajax/multiple select2.
                        elm.bind("change", function () {
                            scope.$apply(function () {
                                controller.$setViewValue(elm.select2('data'));
                            });
                        });

                        if (opts.initSelection) {
                            var initSelection = opts.initSelection;
                            opts.initSelection = function (element, callback) {
                                initSelection(element, function (value) {
                                    controller.$setViewValue(value);
                                    callback(value);
                                });
                            };
                        }
                    }
                }

                attrs.$observe('disabled', function (value) {
                    elm.select2(value && 'disable' || 'enable');
                });

                if (attrs.ngMultiple) {
                    scope.$watch(attrs.ngMultiple, function (newVal) {
                        elm.select2(opts);
                    });
                }

                // Set initial value since Angular doesn't
                elm.val(scope.$eval(attrs.ngModel));

                // Initialize the plugin late so that the injected DOM does not disrupt the template compiler
                $timeout(function () {
                    elm.select2(opts);
                    // Not sure if I should just check for !isSelect OR if I should check for 'tags' key
                    if (!opts.initSelection && !isSelect)
                        controller.$setViewValue(elm.select2('data'));
                });
            };
        }
    };
}]);

itero.directive('billwerkDaterangepicker', ['PUtill', 'DatepickerUtils', function (PUtill, DatepickerUtils) {
    return {
        restrict: 'E',
        scope: {
            dateRange: '=',
            autoRangeOneDay: '<',
            fromLabel: '<',
            toLabel: '<',
            hideClear: '<',
            maxToDate: '<',
            tooltipMode: '<'
        },
        templateUrl: '/partials/controls/daterangepicker.html' + itero.linkVersion,
        controller: ['$scope', 'gettextCatalog', 'gettext', function ($scope, gettextCatalog, gettext) {
            if (!$scope.dateRange)
                $scope.dateRange = { dateFrom: null, dateTo: null };

            if ($scope.fromLabel === undefined)
                $scope.fromLabel = "From";

            if ($scope.toLabel === undefined)
                $scope.toLabel = "To";

            $scope.$watch('dateRange.dateFrom', function (newValue, oldValue) {                
                if ($scope.autoRangeOneDay && !$scope.dateRange.dateTo && !PUtill.areDatesEqual(newValue, oldValue) && newValue) {
                    let newDateTo = moment($scope.dateRange.dateFrom).tz(PUtill.BerlinTzName).add(1, 'days').toDate();
                    DatepickerUtils.markAsAlreadyInBrowserTimezone(newDateTo);
                    $scope.dateRange.dateTo = newDateTo;
                }

                preventDateOverlapErrorIfNeeded(oldValue, $scope.dateRange.dateTo);
            });
            $scope.$watch('dateRange.dateTo', function (newValue, oldValue) {
                if ($scope.autoRangeOneDay && !$scope.dateRange.dateFrom && !PUtill.areDatesEqual(newValue, oldValue) && newValue) {
                    let newDateFrom = moment($scope.dateRange.dateTo).tz(PUtill.BerlinTzName).subtract(1, 'days').toDate();
                    DatepickerUtils.markAsAlreadyInBrowserTimezone(newDateFrom);
                    $scope.dateRange.dateFrom = newDateFrom;
                }

                preventDateOverlapErrorIfNeeded($scope.dateRange.dateFrom, oldValue);
            });
            
            function preventDateOverlapErrorIfNeeded(oldFrom, oldTo) {
                if (!$scope.dateRange || !$scope.dateRange.dateTo || !$scope.dateRange.dateFrom) return;

                if ($scope.dateRange.dateTo < $scope.dateRange.dateFrom) {
                    $scope.$parent.notify("error", gettextCatalog.getString(gettext('Date range end must be before start')));
                    $scope.dateRange.dateFrom = oldFrom;
                    $scope.dateRange.dateTo = oldTo;
                }
            }
        }]
    };
}]);

itero.directive('ngEnter', function () {
    return function (scope, element, attrs) {
        element.bind("keydown keypress", function (event) {
            if (event.which === 13) {
                scope.$apply(function () {
                    scope.$eval(attrs.ngEnter);
                });

                event.preventDefault();
            }
        });
    };
});

var isVisibleAnyCustomPopover = false;
itero.directive('ngPopover', ["$http", "$compile", "$sce", "$templateCache", "AccountLogout",
    function ($http, $compile, $sce, $templateCache, AccountLogout) {

        var ngPopoverController = function ($scope, $rootScope, $http, $location, $window) {
            $scope.firstName = '';
            $scope.lastName = '';
            $scope.roles = [];

            function getRoles (permissions){
                return permissions.Roles;
            }
            
            function openInNewTabWinBrowser(url) {
                var win = $window.open(url, '_blank');
                win.focus();
            }

            $scope.$watch(function () { return localStorage["first_name"] },
                function (newVal) {
                    if (newVal) {
                        $scope.firstName = newVal;
                    }
                }
            );

            $scope.$watch(function () { return localStorage["last_name"] },
                function (newVal) {
                    if (newVal) {
                        $scope.lastName = newVal;
                    }
                }
            );

            $scope.$watch(function () { return localStorage["permissions"] },
                function (newVal) {
                    if (newVal) {
                        var permissions = angular.fromJson(newVal);
                        $scope.roles = getRoles(permissions);
                    }
                }
            );
            
            $scope.logoff = function () {
                let external_user = localStorage["external_user"];
                AccountLogout.logout();
                if (external_user !== undefined && external_user.toLowerCase() === "true")
                    $location.path("/external-logout");
                else
                    $location.path("/login");
            };

            $scope.goToSettings = function() {
                var isAdmin = $scope.roles.indexOf("Admin") !== -1;

                if (isAdmin) {
                    $location.path("/settings/payment-providers-list");
                } else {
                    $location.path("/settings/taxpolicies");
                }
                
            };

            $scope.goToAccountSettings = function() {
                $location.path("/account-settings/company");
            };

            $scope.goToDeveloperDocs = function() {
                openInNewTabWinBrowser("https://docs.frisbii-transform.com/");
            };

            $scope.goToSupportTutorials = function() {
                openInNewTabWinBrowser("https://www.youtube.com/playlist?list=PLkS8wRoJ2UW7gt8YFgGre1zIzfnhUotKr");
            };

            $scope.goToZendesk = function() {
                openInNewTabWinBrowser("https://help.frisbii.com/frisbii-transform/docs");
            };
        };
        ngPopoverController.$inject = ['$scope', '$rootScope', '$http', '$location', '$window'];

        function link(scope, element, attrs) {
            var isCustom = attrs.trigger && attrs.trigger === 'custom',
                templateUrl = attrs.popoverTemplate ? attrs.popoverTemplate + scope.linkVersion : '';

            function hideAllPopovers() {
                $("[data-trigger='custom']").each(function () {
                    $(this).popover('hide');
                });
            };

            $http.get($sce.trustAsResourceUrl(templateUrl), { cache: $templateCache })
                .then(function (response) {
                    $(element).popover({
                        trigger: 'manual',
                        html: true,
                        animation: false,
                        content: function () {
                            return $compile(response.data)(scope);
                        }
                    })
                        .on("mouseover", function () {
                            if (!isCustom) {
                                var _this = $(this);

                                _this.popover("show");
                                _this.next(".popover").one("mouseleave",
                                    function () {
                                        _this.popover('hide');
                                    });
                            }
                        })
                        .on("mouseleave", function () {
                            if (!isCustom) {
                                var _this = $(this);

                                setTimeout(function () {
                                    // if the mouse is not hovering over the popup element, close it
                                    if (!_this.parent().find('.popover:hover').length) {
                                        _this.popover("hide");
                                    }
                                }, 300);
                            }
                        })
                        .on("click", function (e) {
                            if (isCustom) {
                                if (isVisibleAnyCustomPopover) {
                                    hideAllPopovers();
                                }

                                $(element).popover('show');

                                $(element).find('.popover').off('click').on('click', function (e) {
                                    e.stopPropagation();
                                });

                                isVisibleAnyCustomPopover = true;
                                e.stopPropagation();

                            } else {
                                e.preventDefault();
                            }
                        });
                });

            if (isCustom) {
                $(document).on('click',
                    function () {
                        isVisibleAnyCustomPopover = false;
                        hideAllPopovers();
                    });
            }
        };

        return {
            restrict: 'A',
            replace: true,
            scope: true,
            link: link,
            controller: ngPopoverController
        };
    }
]);

itero.directive('ngClickPopover', ["$http", "$compile",
    function ($http, $compile) {
        return {
            restrict: 'A',
            scope: true,
            link: function(scope, element, attrs) {
                var templateUrl = attrs.popoverTemplate ? attrs.popoverTemplate + scope.linkVersion : null,
                    fromCache = !(attrs.fromCache == null);

                $http.get(templateUrl, { cache: fromCache })
                    .then(function(response) {
                        $(element).popover({
                            trigger: "manual",
                            html: true,
                            animation: false,
                            content: function() { return $compile(response.data)(scope) }
                        }).on("click",
                            function(event) {
                                event.preventDefault();

                                var _this = $(this),
                                    _isOpen = _this.next(".popover").length ? true : false;

                                if (!_isOpen) {
                                    // first close if any previous popovers were opened
                                    $(document).trigger("click.ClickPopover");

                                    // open popover
                                    _this.popover("show");

                                    // attach new click handler to close this popover
                                    $(document).one("click.ClickPopover",
                                        function(e) {
                                            _this.popover("hide");
                                        });

                                    // stop this click propagation
                                    event.stopPropagation();
                                }
                            });
                    });
            }
        };
    }
]);

itero.directive('insertAtCaret', ['$timeout', function ($timeout) {
    return {
        restrict: 'EAC',
        scope: {
            innertext: "@innerText",
            affectedid: "@affectedId"
        },
        template: "{{innertext}}",
        link: function (scope, element, attrs) {
            element.bind('click', function () {
                $timeout(function () {
                    if (scope.affectedid) {
                        var el = angular.element(document.querySelectorAll("[id='textarea" + scope.affectedid + "']"));
                        var domElement = el[0];
                        var val = '{' + element[0].innerHTML + '}';
                        if (document.selection) {
                            domElement.focus();
                            var sel = document.selection.createRange();
                            sel.text = val;
                            domElement.focus();
                        } else if (domElement.selectionStart || domElement.selectionStart === 0) {
                            var startPos = domElement.selectionStart;
                            var endPos = domElement.selectionEnd;
                            var scrollTop = domElement.scrollTop;
                            domElement.value = domElement.value.substring(0, startPos) + val + domElement.value.substring(endPos, domElement.value.length);
                            domElement.focus();
                            domElement.selectionStart = startPos + val.length;
                            domElement.selectionEnd = startPos + val.length;
                            domElement.scrollTop = scrollTop;
                        } else {
                            domElement.value += val;
                            domElement.focus();
                        }
                        el.triggerHandler('input'); //.data('$ngModelController', domElement.value);
                    }
                });
            });
        }
    };
}]);

itero.directive('ngFocus', ['$parse', function ($parse) {
    return function(scope, element, attr) {
        var fn = $parse(attr['ngFocus']);
        element.bind('focus',
            function(event) {
                scope.$apply(function() {
                    fn(scope, { $event: event });
                });
            });
    };
}]);

itero.directive('ngBlur', ['$parse', function ($parse) {
    return function(scope, element, attr) {
        var fn = $parse(attr['ngBlur']);
        element.bind('blur',
            function(event) {
                scope.$apply(function() {
                    fn(scope, { $event: event });
                });
            });
    };
}]);

itero.directive('filereset', ['$timeout', function ($timeout) {
    return {
        link: function ($scope, elem, attrs) {
            if (attrs.filereset) {
                $scope.$watch(attrs.filereset, function (newValue, oldValue) {
                    if (newValue !== oldValue) {
                        $timeout(function () {
                            elem[0].value = '';
                        });
                    }
                });
            }
        }
    };
}]);

itero.directive('disallowSpaces', function () {
    return {
        restrict: 'A',

        link: function ($scope, $element) {
            $element.bind('input', function (ev) {

                var el = ev.currentTarget;
                el.value = el.value.replace(/ /g, '');
            });
        }
    };
});

itero.directive('passwordStrengthMeter', [function () {
    return {
        restrict: 'E',
        scope: {
            estimationResult: '=estimationResult'
        },
        templateUrl: '/partials/controls/password-strength-meter.html' + itero.linkVersion,
        replace: true
    };

    gettext("TooShort");
    gettext("TooWeak");
    gettext("Weak");
    gettext("Acceptable");
    gettext("Good");
    gettext("Strong");
}]);

itero.filter('maskLong', function () {
    return function(input, max, start, end) {
        var _max = max || 20;
        var _start = start || 10;
        var _end = end || 5;

        if (input && input.length >= _max) {
            return input.substring(0, _start) + '...' + input.substring(input.length - _end);
        }
        return input;
    };
});

itero.directive('svgContainer', ["$http", "$templateCache",
    function ($http, $templateCache) {
        return {
            restrict: 'E',
            link: function (scope, element, attrs) {
                if (attrs.src) {
                    $http.get(attrs.src, { cache: $templateCache })
                        .then(function (response) {
                            if (response.data) {
                                var wrapElem = angular.element("<div style='width:" + attrs.width + ";height:" + attrs.height + ";'></div>");
                                wrapElem.append(response.data);
                                element.append(wrapElem);
                            }
                        });
                }
            }
        };
    }
]);

itero.directive('alert', function () {
    return {
        restrict: 'EA',
        templateUrl: 'partials/uib-wrappers/alert.html',
        transclude: true,
        scope: {
            type: '=',
            close: '&'
        },
        link: function (scope, elem, $attrs) {
            scope.$watch(
                function () {
                    var div = elem[0].querySelector('div[uib-alert]');
                    return div && div.innerHTML && div.innerHTML.length ? div.innerHTML.length : undefined;
                },
                function () {
                    angular.element(elem[0].querySelector('div[uib-alert]')).removeClass('alert');
                    if (!$attrs.close) {
                        var closeBtn = angular.element(elem[0].querySelector('.close'));
                        if (closeBtn) {
                            closeBtn.css('display', 'none');
                        }
                    }
                });
        }
    };
});

itero.directive('attachmentsFileUploader', function () {
    return {
        restrict: 'E',
        scope: {
            attachment: '=',
            uploading: '=',
            isError: '=',
            maxSize: '=',
            url: '=',
            buttonText: '=',
            saveFunc: '=',
            deleteFunc: '=',
            errorMessage: '=',
            onSuccessCallback: '&onSuccessCallback',
            acceptType: '=' //Can be used to override the allowed file types restrictions. Currently supports jpeg, png or reconciliation import formats.
        },
        templateUrl: '/partials/controls/attachments-uploader.html' + itero.linkVersion,
        link: function (scope, element, attr, ctrl) {

            var hiddenElement = element.find('#uploadFile');
            var btn = element.find('#uploadBtn');

            if (scope.acceptType && scope.allowedFileType)
                hiddenElement.attr('accept', scope.allowedFileType.accept);

            //We hided the uploader and added new input and button(btn).
            //If we click the button so we trigger "click" event from uploader(hiddenElement)
            btn.click(function () {
                hiddenElement.click();
            });

            scope.saveFunc = function () {
                if (!scope.isError) {
                    scope.uploading = true;
                    scope.uploader.uploadAll();
                    return true;
                } else {
                    return false;
                }
            };

            scope.deleteFunc = function () {
                scope.cleanFileInfo();
                scope.removeLatestAddedFile();
                scope.cleanError();
            };
        },

        controller: [
            '$scope', '$rootScope', 'FileUploader', 'kilobytesFilter', function ($scope, $rootScope, FileUploader, kilobytesFilter) {
                
                $scope.$watch('url', function (newValue) {
                    if (newValue) {
                        $scope.uploader.url = newValue;
                    }
                });

                $scope.uploader = new FileUploader({
                    url: $scope.url,
                    removeAfterUpload: true
                });

                $rootScope.setEssentialHeadersOnUploader($scope.uploader);

                var setupError = function (message) {
                    $scope.isError = true;
                    $scope.$parent.errorMessage = message;
                };

                $scope.removeLatestAddedFile = function () {
                    if ($scope.uploader.queue.length > 0) {
                        $scope.uploader.queue.shift();
                        document.getElementById("uploadFile").value = "";
                    }
                };

                var isUploadedItemTypeAllowed = function (item) {
                    var isMimeTypeAllowed = $scope.allowedFileType.mimeTypes.indexOf(item.type) > -1;

                    // Check if the file ends with .c53 and $scope.acceptType is reconciliationImports
                    var isC53FileAllowed = item.name.toLowerCase().endsWith('.c53') && $scope.acceptType === 'reconciliationImports';
                    
                    return isMimeTypeAllowed || isC53FileAllowed;
                };

                $scope.uploader.filters.push({
                    name: 'typeFilter',
                    fn: function (item, options) {
                        var result = isUploadedItemTypeAllowed(item);
                        if (!result) {
                            setupError('Invalid type: ' + item.type);
                            document.getElementById("uploadFile").value = "";
                        }
                        return result;
                    }
                });

                $scope.uploader.filters.push({
                    name: 'nameFilter',
                    fn: function (item, options) {
                        var Regexp = new RegExp("[\\/:*?\"<>|]");
                        var result = Regexp.test(item.name);
                        if (result) {
                            setupError('Invalid FileName: ' + item.name);
                            document.getElementById("uploadFile").value = "";
                        }
                        return !result;
                    }
                });

                $scope.cleanFileInfo = function () {
                    $scope.attachment.Files['_c'].FileName = '';
                    $scope.attachment.Files['_c'].FileSize = '';
                };

                $scope.cleanError = function () {
                    $scope.isError = false;
                    $scope.errorMessage = '';
                };
                
                $scope.allowedFileType = function () {
                    var fileType;
                    switch ($scope.acceptType) {
                        case 'basicImages':
                            fileType = {
                                accept: '.jpeg, .jpg, .png',
                                mimeTypes: ['image/jpeg', 'image/png']
                            };
                            break;
                        case 'reconciliationImports':
                            fileType = {
                                accept: '*',
                                mimeTypes: ['text/csv',
                                    'text/x-csv',
                                    'application/x-csv',
                                    'text/xml',
                                    'text/plain',                                            
                                    'application/csv',
                                    'application/xml',
                                    'application/txt',
                                    'text/comma-separated-values',
                                    'application/excel',
                                    'application/vnd.ms-excel',
                                    'application/vnd.msexcel',
                                    'text/anytext',
                                    'application/octet-stream',
                                    'text/x-comma-separated-values'
                                ]
                            };
                            break;
                        default:
                            fileType = {
                                accept: '.pdf',
                                mimeTypes: ['application/pdf']
                            };
                            break;
                    }
                    return fileType;
                }();

                var checkFileSize = function (size) {
                    if (size > $scope.maxSize) {
                        $scope.cleanFileInfo();
                        $scope.removeLatestAddedFile();
                        setupError('Invalid size - ' + kilobytesFilter(size) + '.');
                    } else {
                        $scope.cleanError();
                    }
                };

                var onBeforeUploadItem = function (item) {
                    item.formData.push({
                        InternalName: $scope.attachment.InternalName,
                        Id: $scope.attachment.Id,
                        AttachmentContentId: $scope.attachment.Files['_c'].FileId
                    });
                };

                var onAfterAddingFile = function (item) {
                    if (item.file) {
                        $scope.attachment.Files['_c'].FileName = item.file.name;
                        $scope.attachment.Files['_c'].FileSize = item.file.size;
                        $scope.attachment.Files['_c'].FileId = '000000000000000000000000';

                        checkFileSize(item.file.size);
                    }
                };

                var onSuccessItem = function (item, response, status, headers) {
                    $scope.uploading = false;
                    $scope.cleanError();
                    console.log("item created");
                    $scope.$parent.successResponse = response;
                    $scope.onSuccessCallback();
                };

                var onErrorItem = function (item, response, status, headers) {
                    $scope.uploading = false;
                    $scope.cleanFileInfo();
                    $scope.$parent.errorResponse = response;
                    setupError(response.message);
                };

                $scope.uploader.onSuccessItem = onSuccessItem;
                $scope.uploader.onErrorItem = onErrorItem;
                $scope.uploader.onAfterAddingFile = onAfterAddingFile;
                $scope.uploader.onBeforeUploadItem = onBeforeUploadItem;
            }
        ]
    };
});


itero.directive('multipleFilesUploader', function () {
    return {
        restrict: 'E',
        scope: {
            uploader: "=",            
            maxSize: '=',
            maxCount: '=',
            url: '=',            
            errorMessage: '='
        },
        templateUrl: '/partials/controls/multiple-files-uploader.html' + itero.linkVersion,
        link: function (scope, element, attr, ctrl) {
        },

        controller: [
            '$scope', '$rootScope', 'FileUploader', 'kilobytesFilter', function ($scope, $rootScope, FileUploader, kilobytesFilter) {
                $scope.uploader = new FileUploader({
                    url: $scope.url,
                    removeAfterUpload: true
                });

                $rootScope.setEssentialHeadersOnUploader($scope.uploader);

                var setupError = function (message) {                    
                    $scope.$parent.errorMessage = message;
                };

                var isUploadedItemTypeAllowed = function (item) {
                    return getAllowedFileTypes().indexOf(item.type) > -1;
                };

                $scope.uploader.filters.push({
                    name: 'typeFilter',
                    fn: function (item, options) {
                        var result = isUploadedItemTypeAllowed(item);
                        if (!result) {
                            setupError('Invalid type: ' + item.type);
                        }
                        return result;
                    }
                });

                $scope.uploader.filters.push({
                    name: 'fileCountFilter',
                    fn: function () {
                        return this.queue.length < $scope.maxCount;
                    }
                });

                $scope.uploader.filters.push({
                    name: 'sizeFilter',
                    fn: function (item, options) {
                        var result = (item.size <= $scope.maxSize);
                        if (!result) {
                            setupError('Invalid size - ' + item.name + ' - ' + kilobytesFilter(item.size) + '.');
                        }
                        return result;
                    }
                });

                $scope.uploader.filters.push({
                    name: 'nameFilter',
                    fn: function (item, options) {
                        var Regexp = new RegExp("[\\/:*?\"<>|]");
                        var result = Regexp.test(item.name);
                        if (result) {
                            setupError('Invalid FileName: ' + item.name);                           
                        }
                        return !result;
                    }
                });

                $scope.cleanError = function () {                   
                    $scope.errorMessage = '';
                };

                var getAllowedFileTypes = function () {
                    return ['text/csv',
                        'text/plain',
                        'application/csv',
                        'application/txt',
                        'text/comma-separated-values',
                        'application/vnd.ms-excel',
                        'application/vnd.msexcel',
                        'text/x-csv',
                        'application/csv',
                        'application/x-csv',
                        'text/x-comma-separated-values'
                    ]
                };

                var onSuccessItem = function (item, response, status, headers) {                    
                    $scope.cleanError();
                    console.log("item created");
                };

                var onErrorItem = function (item, response, status, headers) {                    
                    setupError(response.message);
                };

                $scope.uploader.onSuccessItem = onSuccessItem;
                $scope.uploader.onErrorItem = onErrorItem;
                $scope.uploader.onCompleteItem = $scope.$parent.onCompleteItem;
            }
        ]
    };
});

itero.directive('ngFile', ['$parse', function ($parse) {
    function fn_link(scope, element, attrs) {
        var onChange = $parse(attrs.ngFile);
        element.on('change', function (event) {
            onChange(scope, { $files: event.target.files });
        });
    };

    return {
        link: fn_link
    }
}]);

itero.directive('disableAll', DisableAll);

itero.directive('checklistModel', ['$parse', '$compile', function ($parse, $compile) {
    
    function add(arr, item) {
        arr = angular.isArray(arr) ? arr : [];
        for (var i = 0; i < arr.length; i++) {
            if (angular.equals(arr[i], item)) {
                return arr;
            }
        }
        arr.push(item);
        return arr;
    }
    
    function remove(arr, item) {
        if (angular.isArray(arr)) {
            for (var i = 0; i < arr.length; i++) {
                if (angular.equals(arr[i], item)) {
                    arr.splice(i, 1);
                    break;
                }
            }
        }
        return arr;
    }

    // http://stackoverflow.com/a/19228302/1458162
    function postLinkFn(scope, elem, attrs) {
        // compile with `ng-model` pointing to `checked`
        $compile(elem)(scope);

        // getter / setter for original model
        const getter = $parse(attrs.checklistModel);
        const setter = getter.assign;

        // value added to list
        const value = $parse(attrs.checklistValue)(scope.$parent);
        
        const userRolesCheckBoxesSet = $parse(attrs.userRolesCheckBoxesSet);

        // watch UI checked change
        scope.$watch('checked', function (newValue, oldValue) {
            if (userRolesCheckBoxesSet) {
                resolveCallForUserRolesCheckBoxesSet(newValue, oldValue)
            } else {
                resolveCall(newValue, oldValue)
            }
        });

        function resolveCall(newValue, oldValue) {
            if (newValue === oldValue) {
                return;
            }

            var current = getter(scope.$parent);
            if (newValue === true) {
                setter(scope.$parent, add(current, value));
            } else {
                setter(scope.$parent, remove(current, value));
            }
        }

        //HACK for user roles only
        function resolveCallForUserRolesCheckBoxesSet(newValue, oldValue) {

            if (newValue === oldValue) {
                return;
            }

            var current = getter(scope.$parent);

            if (newValue === true) {

                current = checkExclusiveRoles(current, 'Admin');
                current = checkExclusiveRoles(current, 'ReadOnlyOperations');
                current = checkExclusiveRoles(current, 'Developer');

                setter(scope.$parent, add(current, value));
 
            } else {
                setter(scope.$parent, remove(current, value));
            }
        }

        function checkExclusiveRoles(current, roleToCheck) {

            let alreadyHasRoleButTryToAddOtherRole = current.includes(roleToCheck) && value !== roleToCheck;
            let isTryingToAddExclusiveRole = !current.includes(roleToCheck) && current.length > 0 && value === roleToCheck;

            if (alreadyHasRoleButTryToAddOtherRole) {
                return current.filter(function (_) { return _ !== roleToCheck });
            }
            else if (isTryingToAddExclusiveRole) {
                return [];
            }

            return current;
        }

        // watch original model change
        scope.$parent.$watch(attrs.checklistModel, function (newArr, oldArr) {
            if(newArr) {
                scope.checked = newArr.includes(value);
            }
        }, true);
    }

    return {
        restrict: 'A',
        priority: 1000,
        terminal: true,
        scope: true,
        compile: function (tElement, tAttrs) {
            if (tElement[0].tagName !== 'INPUT' || !tElement.attr('type', 'checkbox')) {
                throw 'checklist-model should be applied to `input[type="checkbox"]`.';
            }

            if (!tAttrs.checklistValue) {
                throw 'You should provide `checklist-value`.';
            }

            // exclude recursion
            tElement.removeAttr('checklist-model');

            // local scope var storing individual checkbox model
            tElement.attr('ng-model', 'checked');

            return postLinkFn;
        }
    };
}]);

itero.directive('multiSelectTree',
    function () {
        return {
            restrict: 'E',
            templateUrl: 'app/js/components/tree/multi-select-tree.tpl.html',
            scope: {
                inputModel: '=',
                outputModel: '=?',
                multiSelect: '=?',
                switchView: '=?',
                switchViewLabel: '@',
                switchViewCallback: '&',
                selectOnlyLeafs: '=?',
                callback: '&',
                searchCallback: '&',
                defaultLabel: '@',
                isSelectInput: '=?',
                isSearchInput: '=?',
                allowUnselect: '=?',
            },
            link: function (scope, element, attrs) {
                if (attrs.callback) {
                    scope.useCallback = true;
                }

                scope.multiSelectStates = Object.freeze({
                    NonInitialized : 0,
                    OutputAsTree : 1,
                    PendingForSearch : 2,
                    SearchResultAsList : 3,
                    SearchResultAsTree : 4,
                })

                scope.currentState = scope.multiSelectStates.NonInitialized;

                // watch for changes in input model as a whole
                // this on updates the multi-select when a user load a whole new input-model.
                scope.$watch('inputModel', function (newVal, oldVal) {
                    if (newVal === undefined){
                        return;
                    }
                    scope.changeTreeState(newVal.newState);
                }, true);

                /**
                 * Return all childNodes of a given node (as Array of Nodes)
                 */
                function getAllChildNodesFromNode(node, childNodes) {
                    for (var i = 0; i < node.children.length; i++) {
                        childNodes.push(node.children[i]);
                        // add the childNodes from the children if available
                        getAllChildNodesFromNode(node.children[i], childNodes);
                    }
                    return childNodes;
                }
            },
            controller: MultiSelectTreeController
        };
    });


itero.directive('treeItem', ['$compile',
    function ($compile) {
        return {
            restrict: 'E',
            templateUrl: 'app/js/components/tree/tree-item.tpl.html',
            scope: {
                item: '=',
                itemSelected: '&',
                onActiveItem: '&',
                multiSelect: '=?',
                selectOnlyLeafs: '=?',
                isActive: '=', // the item is active - means it is highlighted but not selected
                useCallback: '=',
                canSelectItem: '=' // reference from the parent control
            },
            controller: TreeItemController,
            /**
             * Manually compiles the element, fixing the recursion loop.
             * @param element
             * @param [link] A post-link function, or an object with function(s) registered via pre and post properties.
             * @returns An object containing the linking functions.
             */
            compile: function (element, attrs, link) {
                // Normalize the link parameter
                if (angular.isFunction(link)) {
                    link = {post: link};
                }

                // Break the recursion loop by removing the contents
                var contents = element.contents().remove();
                var compiledContents;
                return {
                    pre: (link && link.pre) ? link.pre : null,
                    /**
                     * Compiles and re-adds the contents
                     */
                    post: function (scope, element, attrs) {
                        // Compile the contents
                        if (!compiledContents) {
                            compiledContents = $compile(contents);
                        }
                        // Re-add the compiled contents to the element
                        compiledContents(scope, function (clone) {
                            element.append(clone);
                        });

                        // Call the post-linking function, if any
                        if (link && link.post) {
                            link.post.apply(null, arguments);
                        }
                    }
                };
            }
        };
    }]);

itero.directive('taxRequestDetails', function () {
    return {
        restrict: 'EA',
        scope: { taxrequest: '=', loading: '=', heightBlockId: '=' },
        templateUrl: 'partials/tax-request-details.html' + itero.linkVersion,
        replace: true,
    };
});

itero.directive('externalTransactionRequestDetails', function () {
    return {
        restrict: 'EA',
        scope: {externalTransactionRequest: '=', heightBlockId: '='},
        templateUrl: 'partials/external-transaction-request-details.html' + itero.linkVersion,
        replace: true,
    };
});

itero.directive('priceEditor', function () {
    return {
        restrict: 'E',
        scope: {data: '=ngModel', currencyValue: '=currencyValue', hideComplexPrices: '=hideComplexPrices' , readOnly: '='},
        templateUrl: '/partials/controls/price-editor.html' + itero.linkVersion,
        controller: ['$scope', '$uibModal', 'gettextCatalog', 'gettext',
            function ($scope, $modal, gettextCatalog, gettext) {
                $scope.openEditor = function () {
                    $scope.oldData = JSON.parse(JSON.stringify($scope.data));
                    var modalInstance = $modal.open({
                        templateUrl: '/partials/controls/price-editor-dialog.html' + itero.linkVersion,
                        controller: PriceControlController,
                        windowClass: "fade in",
                        resolve: {
                            data: function () {
                                return $scope.data;
                            }, currencyValue: function () {
                                return $scope.currencyValue;
                            }, hideComplexPrices: function () {
                                return $scope.hideComplexPrices;
                            },
                        },
                        scope: $scope
                    });
                    modalInstance.result.then(null, function (response) {
                        if (response === 'cancel') {
                            $scope.data = $scope.oldData;
                        }
                    });
                };

                $scope.enterKeyHandler = function(event) {
                    if (event.keyCode === 13)
                        event.preventDefault();
                };

                $scope.getValue = function () {
                    if ($scope.data == null)
                        return "";
                    if ($scope.data.PriceScale == null && $scope.data.DiscountScale == null && $scope.data.PricePerUnit == null)
                        return gettextCatalog.getString(gettext("Free"));
                    if ($scope.data.PriceScale != null && $scope.data.PriceScale.Items != null)
                        return `${getValue($scope.data.PriceScale.Items[0])} / ${getValue($scope.data.PriceScale.Items[1])} / ...`;
                    if ($scope.data.DiscountScale != null && $scope.data.DiscountScale.Items != null)
                        return `${$scope.data.DiscountScale.BasePricePerUnit}, (-${getValue($scope.data.DiscountScale.Items[0])}% / -${getValue($scope.data.DiscountScale.Items[1])}% / ...)`;
                    if ($scope.data.PricePerUnit != null)
                        return $scope.data.PricePerUnit.toFixed(2);
                    return "";
                };

                $scope.complexPriceSetUp = function () {
                    return !($scope.data)
                        || ($scope.data.PriceScale != null && $scope.data.PriceScale.Items != null)
                        || ($scope.data.DiscountScale != null && $scope.data.DiscountScale.Items != null)
                        || ($scope.data.PriceScale == null && $scope.data.DiscountScale == null && $scope.data.PricePerUnit == null);
                }

                $scope.priceGetterSetter = function (value) {
                    $scope.insertedValue = null;
                    if (value != null) {
                        $scope.insertedValue = value;
                        $scope.data.PricePerUnit = $scope.complexPriceSetUp() ? null : value.replace(',', '.');
                    }
                    return $scope.insertedValue ?? $scope.data.PricePerUnit;
                }

                function getValue(item) {
                    if (item == null) return "";
                    return item.Value;
                }
            }]
    };
});

itero.directive('readOnlyPrice', function () {
    return {
        restrict: 'E',
        scope: {item: '=item', currencyValue: '=currencyValue'},
        templateUrl: '/partials/controls/read-only-price.html' + itero.linkVersion,
    };
});

itero.directive('expandableAmountsPerCurrency', function () {
    return {
        restrict: 'E',
        scope: { items: '=', selected: '='  },
        templateUrl: '/partials/bulk-update/expandable-amounts-per-currency.html' + itero.linkVersion,
        link: function (scope) {
            scope.isCollapsed = true;
     
            scope.onIconClick = function (item) {
                scope.isCollapsed = !scope.isCollapsed;
            };
        }
    };
});

itero.directive('actionsDropdown', function () {
    return {
        restrict: 'E',
        scope: { currentAction: '=ngModel'  },
        templateUrl: '/partials/bulk-update/actions-dropdown.html' + itero.linkVersion,
        controller: ["$scope", "$http", "BulkUpdatesNavigationHelper",
            function ($scope, $http, BulkUpdatesNavigationHelper) {
                getBulkUpdateActions();

                $scope.redirectToAction = function (action) {
                    BulkUpdatesNavigationHelper.redirectToAction(action)
                }

                function getBulkUpdateActions() {
                    $http({
                        method: "GET",
                        url: "/api/v1/bulkoperation/action"
                    }).then(function (response) {
                        $scope.actions = response.data;
                    });
                }
            }]
    };
});

itero.directive('changeDate', function () {
    return {
        restrict: 'E',
        scope: {changeDate: '=changeDate', presetChangeDate: '=presetChangeDate', isContractStartOptionDisabled: '=?disableContractStartOption'},
        templateUrl: '/partials/bulk-update/change-date.html' + itero.linkVersion,
        controller: ["$scope", "DatepickerUtils", function ($scope, DatepickerUtils) {
            $scope.exactDateText = 'Exact Date'
            $scope.showExactDateOption = false;

            $scope.$watch('presetChangeDate', presetChangeDateChanged);
            $scope.$watch('changeDate', changeDateChanged);

            function presetChangeDateChanged(preset) {
                switch (preset) {
                    case 'Now': {
                        $scope.changeDate = new Date();
                        return;
                    }
                    case $scope.exactDateText:
                        return;
                    default: {
                        $scope.showExactDateOption = false;
                        $scope.changeDate = null;
                    }
                }
            }

            function changeDateChanged(date) {
                if (date) {
                    if ($scope.presetChangeDate !== 'Now') {
                        $scope.showExactDateOption = true;
                        $scope.presetChangeDate = $scope.exactDateText;
                    }

                    DatepickerUtils.markAsAlreadyInBrowserTimezone(date);
                }
            }
        }]
    };
});

itero.directive('detailsPanel', function () {
    return {
        restrict: 'E',
        scope: { selectedBulkUpdate: "=bulkOperation", productInfo: "=productInfo" },
        templateUrl: '/partials/bulk-update/details-panel.html' + itero.linkVersion,
        controller: ["$scope", "$http", "$location", "gettext", "ReportDownloadService", "babelFilter", "EmailNotificationsTemplatesByEventCategory",
            function ($scope, $http, $location, gettext, ReportDownloadService, babelFilter, EmailNotificationsTemplatesByEventCategory) {
                const defaultNumberOfSummaryAmountsPerCurrenciesToShow = 3;
                $scope.areSummaryAmountsPerCurrenciesCollapsed = true;
                $scope.numberOfSummaryAmountsPerCurrenciesToShow = defaultNumberOfSummaryAmountsPerCurrenciesToShow;
                $scope.selectedDunningTemplateName = null;
                $scope.reportFormatTooltip = gettext('You can choose the format only for the first attempt of report generation; later downloads don’t provide format options');
                $scope.reportTypePreview = gettext('Preview version');
                $scope.reportTypeExecution = gettext('Execution version');
                $scope.scopeHolder = {reportLocale: "de-DE"};
                
                // cancel contracts info
                $scope.getContractEndDateToDisplay = function (contractEndDate) {
                    switch (contractEndDate) {
                        case 'Now':
                            return 'Now';
                        case 'ContractStart':
                            return 'Contract Start';
                        case 'NextBillingDate':
                            return 'Next Billing Date';
                        case 'LastBillingDate':
                            return 'Last Billing Date';
                        case 'BilledUntil':
                            return 'Billed Until';
                        case 'RegularContractPeriodEnd':
                            return 'Regular Contract Period End';
                        default:
                            return '';
                    }
                }

                $scope.getPaymentEscalation = function (isPaymentEscalation) {
                    switch (isPaymentEscalation) {
                        case true:
                            return 'On';
                        case false:
                            return 'Off';
                        default:
                            return 'All';
                    }
                }

                $scope.getFilterStatusToDisplay = function (status) {
                    if (status === 'InTrial')
                        return 'In Trial';

                    return status;
                }
                
                $scope.$watch('selectedBulkUpdate', bulkOperationChanged);
                function bulkOperationChanged() {
                    if ($scope.selectedBulkUpdate &&
                        $scope.selectedBulkUpdate.Filter &&
                        $scope.selectedBulkUpdate.Filter.CancelContracts)
                        getDunningTemplate($scope.selectedBulkUpdate.Filter.CancelContracts.DunningTemplateId);
                    
                    if ($scope.selectedBulkUpdate &&
                        $scope.selectedBulkUpdate.Parameters &&
                        $scope.selectedBulkUpdate.Parameters.UpgradeContracts)                        
                        getNotificationEmailTemplateName($scope.selectedBulkUpdate.Parameters.UpgradeContracts.EmailTemplateExternalId);
                }
      
                function getDunningTemplate(dunningTemplateId) {
                    if (!dunningTemplateId)
                        $scope.selectedDunningTemplateName =  'All';
                    else {
                        $http({
                            method: "GET",
                            url: "/api/v1/documenttemplates/dunning/" + dunningTemplateId
                        }).then(
                            function (response) {
                                $scope.selectedDunningTemplateName = response.data;
                            }
                        );
                    }
                }

                function getNotificationEmailTemplateName(externalId){
                    if(!externalId)
                        return;
                    if($scope.notificationEmailsTemplates){
                        $scope.selectedEmailTemplate = getTemplateByExternalId($scope.notificationEmailsTemplates, externalId);
                    }
                    else {
                        EmailNotificationsTemplatesByEventCategory.query({ category: 'OrderSucceeded'}).$promise.then(function (response) {
                            $scope.notificationEmailsTemplates = response;
                            $scope.selectedEmailTemplate = getTemplateByExternalId($scope.notificationEmailsTemplates, externalId);
                        });
                    }
                }
                
                function getTemplateByExternalId(templates, externalId){
                    let template = templates.find(o => o.ExternalId === externalId);
                    if(template)
                        return template.InternalName;
                    return externalId;
                }

                //upgrade contracts
                $scope.getComponentName = function(component) {
                    let overrideName = "";
                    if (component.ProductOverride && component.ProductOverride.Name) {
                        overrideName = `${component.ProductOverride.Name} - `;
                    }

                    return `${overrideName}${babelFilter($scope.productInfo.ComponentById(component.ComponentId).Name)} / ${component.Quantity}`;
                }

                $scope.getRatedItemDescriptionAndQuantities = function (ratedItem) {
                    return ratedItem.Description + ' / ' + ratedItem.Quantity;
                }
                $scope.getDiscountName = function(discounts) {
                    return $scope.productInfo.DiscountById(discounts.DiscountId).InternalName;
                }

                // summary
                $scope.getSummaryAmountsPerCurrenciesTitle = function () {
                    if (!$scope.selectedBulkUpdate)
                    return '';
                    
                    switch ($scope.selectedBulkUpdate.Status) {
                    case 'Preview':
                        return gettext("Gross amount previewed");
                    case 'Executed':
                        return gettext("Gross amount previewed / executed");
                    default:
                        return '';
                    }
                }
                
                $scope.getSummaryAmountsPerCurrencies = function (item) {
                    switch ($scope.selectedBulkUpdate.Status) {
                    case 'Preview':
                        return item.Value + ' ' + item.Key;
                    case 'Executed':
                        let executedItem = $scope.selectedBulkUpdate.Summary.GrossAmountsPerCurrencyExecuted.find(o => o.Key === item.Key);
                        let executedAmount = executedItem ? executedItem.Value : 0;
                    
                        return item.Value + ' / ' + executedAmount + ' ' + item.Key;
                    default:
                        return '-';
                    }
                }
                
                $scope.getSummaryNumberOfContractsTitle = function () {
                    if (!$scope.selectedBulkUpdate)
                    return '';
                    
                    switch ($scope.selectedBulkUpdate.Status) {
                    case 'Preview':
                        return gettext("Number of contracts previewed");
                    case 'Executed':
                        return gettext("Number of contracts previewed / successfully changed");
                    default:
                        return '';
                    }
                }
                
                $scope.getSummaryNumberOfContracts = function () {
                    switch ($scope.selectedBulkUpdate.Status) {
                    case 'Preview':
                        return $scope.selectedBulkUpdate.Summary.NumberOfContractsPreviewed;
                    case 'Executed':
                        return $scope.selectedBulkUpdate.Summary.NumberOfContractsPreviewed + ' / ' + $scope.selectedBulkUpdate.Summary.NumberOfContractsExecuted;
                    default:
                        return null;
                    }
                }
                
                $scope.summaryAmountsPerCurrenciesOnClick = function () {
                    $scope.areSummaryAmountsPerCurrenciesCollapsed = !$scope.areSummaryAmountsPerCurrenciesCollapsed;
                    if ($scope.areSummaryAmountsPerCurrenciesCollapsed)
                    $scope.numberOfSummaryAmountsPerCurrenciesToShow = defaultNumberOfSummaryAmountsPerCurrenciesToShow;
                    else
                    $scope.numberOfSummaryAmountsPerCurrenciesToShow = $scope.selectedBulkUpdate.Summary.GrossAmountsPerCurrencyPreviewed.length;
                }
    
                // reporting
                $scope.createReport = function (objectId) {
                    let body = {
                        BulkOperationId: objectId,
                        Locale: $scope.scopeHolder.reportLocale,
                    }
                    $http({
                        method: "POST",
                        url: "/api/v1/bulkOperation/report",
                        data: body,
                    }).then(
                        function (data) {
                            if (data && data.Status !== "Failed") {
                                $location.url("/activities/reporting-files?redirected");
                            }
                        }
                    );
                }
                
                $scope.download = function (reportId) {
                    ReportDownloadService.downloadReport(reportId, $scope.parameters,
                        function (downloadInfo) {
                            $scope.$root.downloadFile(downloadInfo.data.Url);
                        });
                };
                
                $scope.createReportMode = function(bulkOperation) {
                    if (bulkOperation) {
                        if (bulkOperation.Status === "Preview" && bulkOperation.PreviewReportId == null)
                            return $scope.reportTypePreview;
                        else if (bulkOperation.Status === "Executed" && bulkOperation.ExecutionReportId == null)
                            return $scope.reportTypeExecution;
                    }
                    
                    return null;
                }
            }]
    };
});

itero.directive('operationsList', function () {
    return {
        restrict: 'E',
        scope: { selectedOperation: "=selected", hasOperationInProgress: "=isAnyInProgress", refreshHandler: "=refresh" },
        templateUrl: '/partials/bulk-update/operations-list.html' + itero.linkVersion,
        controller: ["$scope", "$http", "BulkUpdates",
            function ($scope, $http, BulkUpdates) {
                $scope.pageTake = 20;
                $scope.showOutdatedPreviews = false;
                $scope.bulkOperations = null;

                $scope.$watch("refreshHandler", function(handler) {
                    handler.refresh = getBulkUpdates;
                });

                $scope.$watch('bulkOperations.items', function (items) {
                    if ((items || []).length > 0) {
                        selectBulkUpdate($scope.showOutdatedPreviews);

                        $scope.hasOperationInProgress = items.some(function (x) {
                            return x.IsInProcessing;
                        });

                        if (!$scope.anyNotOutdated())
                            $scope.showOutdatedPreviews = true;

                        enableAutoreloadIfNeeded();
                    } else {
                        $scope.selectedBulkUpdate = null;
                    }
                });
                
                getBulkUpdates();

                function getBulkUpdates() {
                    $scope.bulkOperations = $scope.$root.paginator(BulkUpdates.query, { showOutdated: $scope.showOutdatedPreviews }, $scope.pageTake, true);
                }

                $scope.showOutdatedPreviewsChanged = function() {
                    getBulkUpdates();
                }

                $scope.setSelectedBulkUpdate = function (id) {
                    $scope.selectedOperation = $scope.bulkOperations.items.filter(function (x) {
                        return x.Id === id;
                    })[0];
                };

                $scope.getBulkOperationTypeName = function (type) {
                    switch (type) {
                        case 'CancelContract':
                            return 'Cancelation';
                        case 'UpgradeContract':
                            return 'Up-/Downgrade';
                        case 'WriteOff':
                            return 'Write-off';
                        default:
                            return '-';
                    }
                }

                $scope.anyNotOutdated = function () {
                    let numberOfNotOutdated = $scope.numberOfNotOutdated();
                    return numberOfNotOutdated > 0 && $scope.bulkOperations.items.length >= numberOfNotOutdated;
                }
 
                $scope.numberOfNotOutdated = function () {
                    return $scope.bulkOperations.items.filter(function (x) {
                        return x.Status !== "Outdated";
                    }).length;
                }
 
                $scope.allPreviewsOfPageAreOutdated = function () {
                    let itIs = !$scope.anyNotOutdated() && !$scope.showOutdatedPreviews && $scope.bulkOperations.items.length > 0;
                    if (itIs)
                        $scope.selectedOperation = null;

                    return itIs;
                }

                function selectBulkUpdate(showOutdated) {
                    if (!$scope.selectedOperation)
                        $scope.selectedOperation = $scope.bulkOperations.items[0];
                    if (!$scope.selectedOperation)
                        return;

                    let updatedSelectedOperation = $scope.bulkOperations.items.filter(function (x) { return x.Id === $scope.selectedOperation.Id; })[0];
                    if (!showOutdated && $scope.selectedOperation.Status === "Outdated")
                        $scope.selectedOperation = $scope.bulkOperations.items[0];
                    else if (updatedSelectedOperation)
                        $scope.selectedOperation = updatedSelectedOperation
                    else
                        $scope.selectedOperation = null;
                }

                // autoreload
                let enableAutoreloadIfNeeded = function () {
                    if ($scope.hasOperationInProgress) {
                        if (!$scope.autoreloadObservable)
                            $scope.autoreloadObservable = Rx.Observable.interval(5000).timeInterval().subscribe(function () {
                                if ($scope.bulkOperations && $scope.bulkOperations.pageIndex === 1)
                                    getBulkUpdates();
                            });
                    }
                    else {
                        disableAutoreload();
                    }
                }

                let disableAutoreload = function () {
                    if (!$scope.autoreloadObservable)
                        return;

                    $scope.autoreloadObservable.dispose();
                    $scope.autoreloadObservable = null;
                }
                
                $scope.$on("$destroy", disableAutoreload);
            }]
    };
});

itero.directive('operationsLegend', function () {
    return {
        restrict: 'E',
        scope: { },
        templateUrl: '/partials/bulk-update/operations-legend.html' + itero.linkVersion,
        link: function (scope) {
            scope.isLegendCollapsed = true;
        }
    };
});

itero.directive('expandableList', function () {
    return {
        restrict: 'E',
        scope: { titleLabel: '=', items: '=', getText: '=', nonCollapsableNumberOfItems: '=' },
        templateUrl: '/partials/bulk-update/expandable-list.html' + itero.linkVersion,
        link: function (scope) {
            scope.isCollapsed = true;

            scope.toggle = function () {
                scope.isCollapsed = !scope.isCollapsed;
            };

            scope.getNonCollapsableNumberOfItems = function() {
                return scope.nonCollapsableNumberOfItems && scope.nonCollapsableNumberOfItems > 0 ? scope.nonCollapsableNumberOfItems : 3;
            }
        }
    };
});

itero.directive('highlightDiff', ['$timeout', function($timeout){
    return {
        restrict: 'E',
        scope: { labelText: '=', after: '=', before: '=' },
        templateUrl: '/partials/controls/highlight-diff.html' + itero.linkVersion,
        link: function (scope) {
            scope.states = Object.freeze({
                NonInitialized : 0,
                NewAfterWithoutBefore: 1,
                NewAfterWithBefore: 2,
                EmptyAfterWithBefore: 3,
                NothingChanged: 4,
            })
            
            scope.state = scope.states.NonInitialized;
            scope.showAfter = false;
            scope.showBefore = false;
            scope.shouldHide = true;
            
            scope.shouldHideDirective = function() {
                return !scope.after && !scope.before;
            };
            
            scope.shouldShowAfter = function() {
                switch (scope.state) {
                    case scope.states.NewAfterWithBefore:
                    case scope.states.NewAfterWithoutBefore:
                    case scope.states.NothingChanged:
                        return true;
                    case scope.states.EmptyAfterWithBefore:
                        return false;
                    default:
                        return false;
                }
            }
            
            scope.shouldShowBefore = function() {
                switch (scope.state) {
                    case scope.states.NewAfterWithBefore:
                    case scope.states.EmptyAfterWithBefore:
                        return true;
                    case scope.states.NewAfterWithoutBefore:
                    case scope.states.NothingChanged:
                        return false;
                    default:
                        return false;
                }
            }

            scope.$watchGroup(['after', 'before'], function(newValues, oldValues, scope){
                let after = newValues[0];
                let before = newValues[1];
                
                if (!after && !before)
                    return;
                
                if (!before)
                    scope.state = scope.states.NewAfterWithoutBefore;
                
                else if (!after && before)
                    scope.state = scope.states.EmptyAfterWithBefore;

                else if (after !== before)
                    scope.state = scope.states.NewAfterWithBefore;

                else if (after === before)
                    scope.state = scope.states.NothingChanged;
                
                $timeout(function() {
                    scope.showAfter = scope.shouldShowAfter();
                    scope.showBefore = scope.shouldShowBefore();
                    scope.shouldHide = scope.shouldHideDirective();
                });
            });
        }
    };
}]);
